/**
 * CrudApp.jsx
 * Root component. useCrudApi is called ONCE here — it owns the fetch loop.
 * All mutation handlers flow down as props so no child needs to call the hook.
 */

import { __ } from "@wordpress/i18n";
import { CrudProvider } from "./context/CrudContext";
import useCrudApi from "./hooks/useCrudApi";
import Header from "./components/Header";
import Controls from "./components/Controls";
import CrudTable from "./components/CrudTable";

function MultiRuleProTip() {
    const isPremium = window.WPBean_PGS_Options?.is_premium;
    if (isPremium) return null;

    const upgradeUrl = window.WPBean_PGS_Options?.upgradeUrl || "#";

    return (
        <div className="px-4 sm:px-6 py-3 border-t border-gray-100">
            <p className="text-xs text-gray-400 text-center m-0">
                {__("Pro tip: multiple rules let you show different gallery layouts per product or category.", "wpbean-product-gallery-slider-for-woocommerce")}
                {" "}
                <a
                    href={upgradeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 underline hover:text-gray-500 transition-colors"
                >
                    {__("Upgrade to Pro", "wpbean-product-gallery-slider-for-woocommerce")}
                </a>
            </p>
        </div>
    );
}

function CrudAppInner() {
    const {
        handleToggleStatus,
        handleDuplicate,
        handleTrash,
        handleRestore,
        handlePermanentDelete,
        handleBulkTrash,
        handleBulkRestore,
        handleBulkPermanentDelete,
        handleBulkStatus,
    } = useCrudApi();

    return (
        <div className="mx-auto p-3 sm:p-6 bg-gray-50 min-h-screen">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <Header />
                <Controls
                    onBulkTrash={handleBulkTrash}
                    onBulkRestore={handleBulkRestore}
                    onBulkPermanentDelete={handleBulkPermanentDelete}
                    onBulkStatus={handleBulkStatus}
                />
                <CrudTable
                    onToggleStatus={handleToggleStatus}
                    onDuplicate={handleDuplicate}
                    onTrash={handleTrash}
                    onRestore={handleRestore}
                    onPermanentDelete={handlePermanentDelete}
                />
                <MultiRuleProTip />
            </div>
        </div>
    );
}

export default function CrudApp() {
    return (
        <CrudProvider>
            <CrudAppInner />
        </CrudProvider>
    );
}
